/* import __COLOCATED_TEMPLATE__ from './file-picker.hbs.js'; */
var _dec, _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { getOwner } from '@ember/application';
/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
//@ts-ignore
import { ref } from 'ember-ref-bucket';
import { generateFakePng } from '@intercom/composer-ember/lib/helpers/image';
let FilePicker = (_dec = ref('fileInput'), _class = class FilePicker extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "fileInput", _descriptor, this);
  }
  get allowedTypeList() {
    return this.args.allowedFileTypes.join(',');
  }
  isAllowedType(file) {
    if (this.args.allowedFileTypes.includes('*')) {
      return true;
    }
    return this.args.allowedFileTypes.includes(file.type);
  }
  get isTest() {
    // @ts-expect-error - getOwner().resolveRegistration() returns unknown type
    let ENV = getOwner(this).resolveRegistration('config:environment');
    return ENV.environment === 'test';
  }
  get fakePng() {
    return generateFakePng();
  }
  open() {
    this.fileInput.value = '';
    if (this.isTest) {
      // It is impossible to programmatically trigger file selection so we fake it in test
      let file = new File([this.fakePng], 'Fake png', {
        type: 'image/png'
      }); //eslint-disable-line
      if (this.isAllowedType(file)) {
        if (this.args.multiple) {
          this.args.onFileChosen([file]);
        } else {
          this.args.onFileChosen(file);
        }
      }
    } else {
      this.fileInput.click();
    }
  }
  onChange(e) {
    let target = e.target;
    if (target && target.files) {
      let files = Array.from(target.files);
      if (this.args.multiple) {
        let allowed = files.filter(file => this.isAllowedType(file));
        if (allowed.length) {
          this.args.onFileChosen(allowed);
        }
      } else if (this.isAllowedType(files[0])) {
        this.args.onFileChosen(files[0]);
      }
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "fileInput", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "open", [action], Object.getOwnPropertyDescriptor(_class.prototype, "open"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onChange"), _class.prototype), _class);
export { FilePicker as default };